module.exports = __webpack_public_path__ + "static/media/overlay.ebfa06c8.png";